import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable} from 'rxjs';
import { UIIconsEnum } from '../../enums/icons.enum';
import { IconService } from '../../services/icon.service';
import { UploadState } from '../../enums/upload-state.enum';
import { FileInfo } from '../../interfaces/file-info.interface';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent {
  @Input() file!: FileInfo
  @Input() state!: Observable<UploadState>
  @Input() progress!: Observable<number>
  
  @Output() cancel: EventEmitter<FileInfo> = new EventEmitter()
  @Output() delete: EventEmitter<FileInfo> = new EventEmitter()

  constructor(private iconService: IconService) {}
}
